import { render, staticRenderFns } from "./aiAlarmDetail.vue?vue&type=template&id=5bbe5434&scoped=true"
import script from "./aiAlarmDetail.vue?vue&type=script&lang=js"
export * from "./aiAlarmDetail.vue?vue&type=script&lang=js"
import style0 from "./aiAlarmDetail.vue?vue&type=style&index=0&id=5bbe5434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbe5434",
  null
  
)

export default component.exports